module.exports = __webpack_public_path__ + "img/roadmap-mobile.6b6031fa.jpg";